// extracted by mini-css-extract-plugin
module.exports = {"ProjectPage":"project_ProjectPage__1gu2q"};